import React, { useState, useEffect, useLayoutEffect, useCallback, useContext, useRef } from "react";
import { InputNumber  } from "primereact/inputnumber";

const InputNumerico = ({
    valor,
    // valorInputAnterior,
    onCambio
    // dispatchDCF,
    // registrarItemCommand,
    // actualizarItemCommand,
    // buscarUnSoloItemCommand,
}) => {
    // const { dispatchPrincipal } = useContext(GlobalContext);

    // const isMounted = useRef(false);
    // const [estadoControl, setForceUpdate] = useState(10);
    // const inputnumeral = useRef(null);
    const ultimoInputValido = useRef("");
    const ultimoSelectionStart = useRef("");
    const ultimoSelectionEnd = useRef("");

    return( <InputNumber 
                onChange={(e) => {                             
                    console.log("---onChange--- InputNumerico Componente");
                    const inputEntrante = e.value;
                            
                    const stringNumberEntrante = inputEntrante.toFixed(2);
                    // if(!inputEntrante.match(/^S\/\s(([1-9]\d{0,8})|0)?(\.\d{2})?$/)){
                    if(!stringNumberEntrante.match(/^(([1-9]\d{0,8})|0)(\.\d{2})$/)){
                    // if(!inputEntrante.match(/^S\/\s(([1-9]\d{0,8})|0)(\.\d{2})$/)){
                            
                        console.log("valor: "+e.originalEvent.target.value);
                        e.originalEvent.target.value= ultimoInputValido.current;
                        e.originalEvent.target.selectionStart=ultimoSelectionStart.current;
                        e.originalEvent.target.selectionEnd=ultimoSelectionEnd.current;
                        return;
                    }

                    ultimoInputValido.current =  e.originalEvent.target.value;
                    ultimoSelectionStart.current = e.originalEvent.target.selectionStart;;
                    ultimoSelectionEnd.current = e.originalEvent.target.selectionEnd;;

                    onCambio(e);
                    
                }}
                value={valor}
                placeholder={"S/ 0.00"}
                minFractionDigits={2}
                maxFractionDigits={2}
                mode="currency" 
                currency="PEN"
                locale="es-PE"
                useGrouping={false}
                inputClassName="p-0 w-32 rounded-none block p-error"
            />                        
                );

};

export {InputNumerico};